// トップスライダーの起動 // Launch the top slider

const swiper = new Swiper(".js-top-swiper", {
  speed: 1000, // スライド変化時間
  loop: true,
  loopAdditionalSlides: 1,
  effect: "fade", // フェード切り替え
  autoplay: {
    delay: 4000, //　スライダー表示時間
    disableOnInteraction: false,
  },
});

//KV下イベントバナー
const commonArgs = {
  speed: 1000, // スライド変化時間
  loop: true,
  // loopAdditionalSlides: 1,
  slidesPerView: 1,
  autoplay: {
    delay: 4000, //　スライダー表示時間
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".js-top-event-swiper .swiper-button-next",
    prevEl: ".js-top-event-swiper .swiper-button-prev",
  },
  breakpoints: {
    // スライドの表示枚数：500px以上の場合
    569: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    769: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
  },
};
var eventArgs = commonArgs;
eventArgs.navigation = {
  nextEl: ".js-top-event-swiper .swiper-button-next",
  prevEl: ".js-top-event-swiper .swiper-button-prev",
};
const slideCount = document.querySelectorAll(".js-top-event-swiper .swiper-slide").length;
console.log(slideCount);
let mySwiper = null;
if (slideCount >= 4) {
  const eventSwiper = new Swiper(".js-top-event-swiper", eventArgs);
} else if (slideCount >= 3 && window.matchMedia("(max-width: 768px)").matches) {
  const eventSwiper = new Swiper(".js-top-event-swiper", eventArgs);
} else if (slideCount >= 2 && window.matchMedia("(max-width: 568px)").matches) {
  const eventSwiper = new Swiper(".js-top-event-swiper", eventArgs);
}

// var playArgs = commonArgs;
// playArgs.navigation = {
//   nextEl: ".js-top-play-swiper .swiper-button-next",
//   prevEl: ".js-top-play-swiper .swiper-button-prev",
// };
// const playSwiper = new Swiper(".js-top-play-swiper", playArgs);

//Gallery
const playSwiper = new Swiper(".js-top-play-swiper", {
  speed: 1000, // スライド変化時間
  loop: true,
  // loopAdditionalSlides: 1,
  slidesPerView: 1,
  autoplay: {
    delay: 4000, //　スライダー表示時間
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".p-frontPlay__cont .swiper-button-next",
    prevEl: ".p-frontPlay__cont .swiper-button-prev",
  },
  breakpoints: {
    // スライドの表示枚数：500px以上の場合
    569: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    769: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
});
//Gallery
const gallerySwiper = new Swiper(".js-top-gallery-swiper", {
  speed: 5000, // スライド変化時間
  loop: true,
  loopAdditionalSlides: 1,
  slidesPerView: 1.7,
  spaceBetween: 10,
  centeredSlides: true,
  allowTouchMove: false, // スワイプ無効
  autoplay: {
    delay: 0, //　スライダー表示時間
    disableOnInteraction: false,
  },
  breakpoints: {
    // スライドの表示枚数：500px以上の場合
    569: {
      slidesPerView: 2.5,
      spaceBetween: 10,
    },
    769: {
      slidesPerView: 3.5,
      spaceBetween: 20,
    },
  },
});

//KV下カテゴリスライダー
const swiperSlides = document.getElementsByClassName("js-top-cateory-swiper");
const breakPoint = 560; // ブレークポイントを設定
let categorySwiper;
let categorySwiperBool;

window.addEventListener(
  "load",
  function () {
    if (breakPoint < window.innerWidth) {
      categorySwiperBool = false;
    } else {
      createSwiper();
      categorySwiperBool = true;
    }
  },
  false
);

window.addEventListener(
  "resize",
  function () {
    if (breakPoint < window.innerWidth && categorySwiperBool) {
      swiperSlides.destroy(false, true);
      categorySwiperBool = false;
    } else if (breakPoint >= window.innerWidth && !categorySwiperBool) {
      createSwiper();
      categorySwiperBool = true;
    }
  },
  false
);

const createSwiper = function () {
  console.log("test");
  categorySwiper = new Swiper(".js-top-cateory-swiper", {
    loop: true, // ループさせる
    speed: 1500, // 少しゆっくり(デフォルトは300)
    slidesPerView: 2,
    centeredSlides: true,
    autoplay: {
      // 自動再生
      delay: 1000, // 1秒後に次のスライド
      disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
    },
    on: {
      afterInit: (swiper) => {
        document.querySelector(".js-top-cateory-swiper").classList.add("is-active");
      },
    },
  });
};

// サムネイルスライダー
window.onload = function () {
  //ラッパー要素を指定
  var sliderWrap = document.querySelectorAll(".js-sliderWrap");
  //サムネイルのスライダーを指定
  var sliderThumb = document.querySelectorAll(".js-slider__thumb");
  //メインのスライダーを指定
  var sliderMain = document.querySelectorAll(".js-slider");
  //slider-wrapの数だけ繰り返す
  for (let i = 0; i < sliderWrap.length; i++) {
    //.slider-wrap、.slider-thumb、.slider-mainに01から始まる連番を振る
    var num = ("00" + (i + 1)).slice(-2);
    sliderWrap[i].className += num;
    sliderThumb[i].className += num;
    sliderMain[i].className += num;
    //サムネイル用のスライダー呼び出し&オプション指定
    var swiperThumb = new Swiper(".js-slider__thumb" + num, {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        569: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });
    //メインのスライダー呼び出し&オプション指定
    var swiperMain = new Swiper(".js-slider" + num, {
      centeredSlides: true,
      thumbs: {
        swiper: swiperThumb,
      },
      slidesPerView: 1,
    });
  }
};
